import { DateTime } from 'luxon';

import { UserSubscription } from '@appTypes/esb';

import { subscriptionIds } from '../constants';
import getActiveSubscription from './getActiveSubscription';

const getSub = (
  currentSubs: UserSubscription[],
  subId: number | string,
  wantsSubscription: boolean,
) => {
  const isOptOut = !wantsSubscription;

  const sub = getActiveSubscription(currentSubs, subId);

  if (!sub && wantsSubscription) {
    return {
      topicId: subId,
      optOutFlag: isOptOut,
      effectiveDt: DateTime.now().toISODate(),
    } as UserSubscription;
  }

  if (sub && sub.optOutFlag !== isOptOut) {
    return {
      ...sub,
      optOutFlag: isOptOut,
      expiryDt: sub.expiryDt ? sub.expiryDt : undefined,
    } as UserSubscription;
  }

  return undefined;
};

export default function formatPhoneSubscriptions(
  formSubs?: boolean[],
  currentSubs: UserSubscription[] = [],
) {
  const result: UserSubscription[] = [];

  if (!formSubs) return result;

  const wantsSubscription = !!formSubs.length;

  const reminderSub = getSub(
    currentSubs,
    subscriptionIds.TEXT,
    wantsSubscription,
  );

  if (reminderSub) {
    result.push(reminderSub);
  }

  return result;
}
